// Empresas que emitem a proposta. O valor escolhido no formulario vai para a
// aba do PDF pelo sessionStorage ("empresa") e define o cabecalho.
export const EMPRESAS = [
  {
    valor: "industria",
    rotulo: "BTK INDÚSTRIA",
    razaoSocial: "BTK SOLUTIONS - INDUSTRIA DE SIRENES LTDA",
    cnpj: "67.998.474/0001-45",
    inscricaoEstadual: "90890745-06",
    endereco: "CEP 83.050-080 - Rua Dolovico Pissaia, 1385",
  },
  {
    valor: "distribuidora",
    rotulo: "BTK DISTRIBUIDORA",
    razaoSocial:
      "BTK SOLUTIONS DIST. DE EQUIP. E INTEGRACAO DE SISTEMAS ELETRONICOS LTDA",
    cnpj: "32.421.603/0001-53",
    inscricaoEstadual: "90890745-06",
    endereco: "CEP 83.050-160 - Rua Professora Marieta de Souza",
  },
];

export const EMPRESA_PADRAO = EMPRESAS[0].valor;

export function buscarEmpresa(valor) {
  return EMPRESAS.find((empresa) => empresa.valor === valor);
}
